<div [ngClass]="mainPage? 'home': 'page'">
<ng-progress #progressBar [color]="'white'"></ng-progress>
<app-menu></app-menu>
<router-outlet></router-outlet>
<app-footer *ngIf="showfooter" [flashOfferEnabled]="flashOffer" [mainPages]="mainPage"></app-footer>
</div>

<!--<router-outlet></router-outlet>-->

